import React, {useCallback, useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';
import {selectLat, selectLng, selectSharingOn, selectUserId, setLocationData, setUserData} from '../../features/liveLocation/liveLocationSlice';
import { getFireBaseData, subscribeToFirebase, queryParser, unSubscribeFromFirebase } from 'helper';
import LocationInfo from './LocationInfo';
import Expired from './Expired';
import SlidingPane from '../../UI/SlidingPane';
import Map from './Map';
import Header from '../../UI/Header/Header';
import DrawerNav from '../../UI/DrawerNav';
import Navigation from '../../UI/Navigation';
import MobileTry from './MobileTry';
import CardsBlock from './CardsBlock';
import {headerHeight, tabletWidth} from '../../mixins';

const LINKS = [
    {
        name: 'Locator App',
        link: 'https://findmy.geozilla.com/'
    }, {
        name: 'Tracking Device',
        link: 'https://gps-tracker.geozilla.com/'
    }, {
        name: 'Driver Protection',
        link: 'https://geozilla.com/driving/'
    }, {
        name: 'Pricing',
        link: 'https://join.geozilla.com/'
    }, {
        name: ' Support',
        link: 'https://geozilla.com/contact/'
    }
];


const StyledWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  
  @media screen and (min-width: ${tabletWidth}) {
    top: ${headerHeight};
  }
`

const StyledMapWrapper = styled.div`
  width: 100%;
  height: calc(100vh - ${headerHeight});
  overflow: hidden;
`


const LiveLocation = (props) => {
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);
    const lat = useSelector(selectLat);
    const lng = useSelector(selectLng);
    const sharingOn = useSelector(selectSharingOn);

    const {
        history: {
            push
        },
        location: {
            search,
        }
    } = props;


    const [slider, setSlider] = useState(isMobileOnly);


    useEffect(() => {
        const preventBehavior = e => e.preventDefault();

        document.addEventListener('touchmove', preventBehavior, {passive: false});
    }, []);


    useEffect(() => {
        const data = queryParser(search);
        getFireBaseData(props.database, '/sharing/', data.id, dispatch, setUserData, ()=>push('/'));
    }, []);

    useEffect(() => {
        userId && subscribeToFirebase(props.database, userId, dispatch, setLocationData);
    }, [userId]);

    useEffect(() => {
        if (!sharingOn) {
            unSubscribeFromFirebase(props.database, userId);
        }
           
    }, [sharingOn]);


    const onWindowResize = useCallback(() => {
        if (window.innerWidth < 767) {
            setSlider(true);
            return;
        }
        setSlider(false);
    }, [window.innerWidth])


    useEffect(() => {
        if (!isMobileOnly) {
            window.addEventListener('resize', onWindowResize);
        }

    }, [])



    const mapBlock = (
        <StyledMapWrapper>
            {(lat && lng) && (<Map/>)}

            {slider ? (
                <SlidingPane>
                    <LocationInfo/>
                    <MobileTry/>
                </SlidingPane>) : <CardsBlock/>
            }
        </StyledMapWrapper>);


    return (
        <>
            <Header bgColor='transparent'>
                {slider ?  <DrawerNav>
                    <Navigation links={LINKS}/>
                </DrawerNav> : <Navigation links={LINKS} responsive={true}/>}
            </Header>
            <StyledWrapper>
                {userId && sharingOn === false ? <Expired /> : mapBlock}
            </StyledWrapper>
        </>
    );
};


export default LiveLocation;